import { Entity } from '../../base/entity';

export class PartnerItem extends Entity {

  public static readonly TABLENAME = 'partner_item';

  public static readonly ID = 'id';
  public static readonly PARTNER_ID = 'partner_id';
  public static readonly PARTNER_ITEM_ID = 'partner_item_id';
  public static readonly ITEM_ID = 'item_id';
  public static readonly ITEM_NAME = 'item_name';

  id: number;
  partnerId: string;
  partnerItemId: string;
  itemId: string | null;

  itemName?: string;
  
}
